<template>
	<div class="LandingComponent">
		<!-- Masthead -->
		<!-- Hero Start -->
		<section class="bg-half-170 d-table w-100" id="home">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6 col-md-7">
						<div class="title-heading mt-4">
							<h1 class="heading mb-3">Real Connection, <br>
								<!--								<span class="element text-primary" data-elements="Agency, Software, Technology, Studio, Webapps"></span>-->
								Virtual Venue</h1>
							<p class="para-desc text-muted">The Real Human Experience for your remote engagements.</p>
							<div class="mt-4">
								<a
									href="javascript:void(0)" data-toggle="modal" data-target="#channelName"
									class="btn btn-primary rounded btn-lg" style="font-size: 18px;"><b> Get Started</b> <i
									class="fas fa-angle-right"></i></a>
							</div>
						</div>
					</div><!--end col-->

					<div class="col-lg-6 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
						<div class="position-relative" data-toggle="modal" data-target="#video" style="cursor: pointer">
							<img src="../assets/7.png" class="rounded img-fluid mx-auto d-block" alt="" id="play-video">
							<div class="play-icon">
								<i class="fas fa-play-circle" style="font-size: 80px;" id="play-video-svg"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12 text-center">
						<div class="section-title mb-4 pb-2">
							<h4 class="title mb-4">What is meetbeans?</h4>
							<p class="text-muted para-desc mb-0 mx-auto">Meetbeans making<span class="font-weight-bold"> remote interactions</span>
								more Connected and Human.</p>
						</div>
					</div><!--end col-->
				</div><!--end row-->

				<div class="row">
					<div class="col-md-4 col-12 mt-5">
						<div class="features text-center">
							<div class="image position-relative d-inline-block">
								<img src="images/icon/user.svg" class="avatar avatar-small w-100" alt="">
							</div>

							<div class="content mt-4">
								<h4 class="title-2">For Meaningful Customer Engagement </h4>
								<p class="text-muted mb-0" style="text-align: justify">Be it a Community Management, Knowledge Webinars,
									Conferences, Meetups, Networking event or a Design Thinking Exercise,
									we have cover it all with real human interaction. Meetbeans
									empowers community managers to be a business saviour for remote teams
									aligning with marketing, sales and product teams.</p>
								<div class="mt-4">
									<a
										href="javascript:void(0)" class="btn btn-primary mt-2" data-toggle="modal"
										data-target="#getStarted" @click="setPurpose('customer_engagement')">Start Engaging
										Customers</a>
								</div>
							</div>
						</div>
					</div><!--end col-->

					<div class="col-md-4 col-12 mt-5">
						<div class="features text-center">
							<div class="image position-relative d-inline-block">
								<img src="images/icon/video.svg" class="avatar avatar-small" alt="">
							</div>

							<div class="content mt-4">
								<h4 class="title-2">For Remote Working Teams</h4>
								<p class="text-muted mb-0" style="text-align: justify">Everybody know the benefits and flexibility of
									remote work,
									but the downside frustration with the loneliness and communication overhead can be counterproductive.
									Meetbeans enable managers to provide virtual office for remote teams engagement and collaboration.</p>
								<div class="mt-5">
									<a
										href="javascript:void(0)" class="btn btn-primary mt-2 text-dark" data-toggle="modal"
										data-target="#getStarted" @click="setPurpose('remote_teams')">Start Remote Working</a>
								</div>
							</div>
						</div>
					</div><!--end col-->

					<div class="col-md-4 col-12 mt-5">
						<div class="features text-center">
							<div class="image position-relative d-inline-block">
								<img src="images/icon/pen.svg" class="avatar avatar-small w-100" alt="">
							</div>

							<div class="content mt-4">
								<h4 class="title-2">For Remote Classrooms</h4>
								<p class="text-muted mb-0" style="text-align: justify">Learning needs to be uninterrupted and
									traditional
									virtual interactions are so inhuman experience which reduces engagement and retention.
									Meetbeans supercharged learning with real classroom experience in virtual venues.
									New Remote Learning Experience for Universities, Schools and Independent Tutors.</p>
								<div class="mt-4">
									<a
										href="javascript:void(0)" class="btn btn-primary mt-2 text-dark"
										data-toggle="modal" data-target="#getStarted" @click="setPurpose('classrooms')">Start Remote
										Learning</a>
								</div>
							</div>
						</div>
					</div><!--end col-->
				</div><!--end row-->
			</div><!--end container-->
		</section><!--end section-->
		<!-- News Start -->
		<section class="section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12 text-center">
						<div class="section-title">
							<h4 class="title mb-4">Special Discount for COVID-19 Support.</h4>
							<p class="text-muted para-desc mx-auto mb-0">Meetbeans started out of
								frustration due to inhuman experience of other virtual conferencing tools and the
								loneliness due to lack of effective communication which we have faced during lock down.
								So, we understand the pain and empathise with you.</p>

							<div class="mt-4">
								<a
									href="javascript:void(0)" class="btn btn-outline-primary mt-2" data-toggle="modal"
									data-target="#getStarted">Sign Up Today</a>
							</div>
						</div>
					</div><!--end col-->
				</div><!--end row-->
			</div><!--end container-->
		</section><!--end section-->
		<!-- News End -->
		<!-- About End -->
		<!-- Footer -->
		<div
			class="modal" id="video" tabindex="-1"
			role="dialog" aria-labelledby="video"
			aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Introducing MeetBeans.</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true" id="close-video">&times;</span>
						</button>
					</div>
					<div class="modal-body p-0 " id="play-youtube-video">
						<iframe
							style="width: 100%; height: 500px;"
							id="play-youtube-video-iframe"
							src="https://www.youtube.com/embed/If53lyybOSU"
							frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</div>
		<div
			class="modal" id="getStarted" tabindex="-1"
			role="dialog" aria-labelledby="getStarted"
			aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Get Started</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-get-started">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label>Name</label>
							<input
								type="email" id="gs-name" class="form-control" v-model="name" aria-describedby="emailHelp"
								required>
						</div>
						<div class="form-group">
							<label>Email address</label>
							<input
								type="email" class="form-control" v-model="email" id="gs-email" required
								aria-describedby="emailHelp">
						</div>
						<div class="form-group">
							<label>Phone Number</label>
							<input
								type="text" class="form-control" v-model="number" required id="gs-number"
								aria-describedby="emailHelp">
						</div>
						<div class="form-group">
							<div class="form-group">
								<label>Select the purpose</label>
								<select class="form-control" v-model="purpose" required id="gs-purpose">
									<option value="customer_engagement">Customer Engagement</option>
									<option value="remote_teams">Remote Working Teams</option>
									<option value="classrooms">Remote Classrooms</option>
								</select>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary text-dark" id="get-started-submit" @click="submitGetStarted">
							<b>Submit</b>
						</button>
					</div>
				</div>
			</div>
		</div>
		<footerComp/>
	</div>
</template>

<script>
  import footerComp from '@/components/footer.vue'

  export default {
    name: 'LandingComponent',
    data() {
      return {
        name: "",
        email: "",
        number: "",
        purpose: ""
      }
    },
    components: {
      footerComp
    },
    created() {
      if (localStorage.getItem('user_info')) {
        this.name = JSON.parse(localStorage.getItem('user_info')).name
        this.email = JSON.parse(localStorage.getItem('user_info')).email
      }
    },
    methods: {
      setPurpose: function (purpose) {
        this.purpose = purpose
        if (localStorage.getItem('user_info')) {
          this.name = JSON.parse(localStorage.getItem('user_info')).name
          this.email = JSON.parse(localStorage.getItem('user_info')).email
        }
      },
      submitGetStarted: function () {
        if (this.name === "") {
          this.$toast.open({
            message: "Please enter name",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.email === "") {
          this.$toast.open({
            message: "Please enter email",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.purpose === "") {
          this.$toast.open({
            message: "Please enter purpose",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.number === "") {
          this.$toast.open({
            message: "Please enter phone number",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          let data = {
            'name': this.name,
            'email': this.email,
            'number': this.number,
            'purpose': this.purpose
          }
          this.$store.dispatch('getStarted', data).then(resp => {
            if (resp.data.status === "success") {
              this.name = ""
              this.email = ""
              this.number = ""
              this.purpose = ""
              document.getElementById('close-get-started').click()
              this.$toast.open({
                message: "Thanks for reaching out, we will get back to you.",
                type: 'success',
				position: 'top',
				queue: true
              });
              var event_name = 'Contact Form';
              window.freshsales.trackEvent(event_name, data);
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
	body {
		font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-weight: 700;
	}

	header.masthead {
		position: relative;
		background-color: #343a40;
		background: url("../assets/bg-1.jpg") no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
		padding-top: 8rem;
		padding-bottom: 8rem;
	}

	header.masthead .overlay {
		position: absolute;
		background-color: #040408;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		opacity: 0.3;
	}

	header.masthead h1 {
		font-size: 2rem;
	}

	@media (min-width: 768px) {
		header.masthead {
			padding-top: 12rem;
			padding-bottom: 12rem;
		}

		header.masthead h1 {
			font-size: 3rem;
		}
	}

	.showcase .showcase-text {
		padding: 3rem;
	}

	.showcase .showcase-img {
		min-height: 30rem;
		background-size: cover;
	}

	@media (min-width: 768px) {
		.showcase .showcase-text {
			padding: 7rem;
		}
	}

	.features-icons {
		padding-top: 7rem;
		padding-bottom: 7rem;
	}

	.features-icons .features-icons-item {
		max-width: 20rem;
	}

	.features-icons .features-icons-item .features-icons-icon {
		height: 7rem;
	}

	.features-icons .features-icons-item .features-icons-icon i {
		font-size: 4.5rem;
	}

	.features-icons .features-icons-item:hover .features-icons-icon i {
		font-size: 5rem;
	}

	.testimonials {
		padding-top: 7rem;
		padding-bottom: 7rem;
		background: #1B1B1B !important;
	}

	.testimonials .testimonial-item {
		max-width: 18rem;
		padding: 25px;
		background: #101010 !important;
		border-radius: 5px;
	}

	.testimonials .testimonial-item img {
		max-width: 12rem;
		box-shadow: 0px 5px 5px 0px #000;
	}

	.call-to-action {
		position: relative;
		background-color: #343a40;
		background: url("../assets/bg-2.jpg") no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
		padding-top: 7rem;
		padding-bottom: 7rem;
	}

	.call-to-action .overlay {
		position: absolute;
		background-color: #212529;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		opacity: 0.3;
	}

	footer.footer {
		padding-top: 4rem;
		padding-bottom: 4rem;
		background: #1B1B1B !important;
	}

	.form-signin .checkbox {
		margin-bottom: 10px;
		margin-top: 10px;
	}
</style>
